<template>

<v-menu offset-y :close-on-content-click="false" :nudge-top="-10" v-model="menu">
  <v-btn class="secondary" dark slot="activator">{{projeto.prazo}}</v-btn>
    <v-card>
      <v-card-text>
        <v-layout row wrap>
        <v-flex xs12>

      <v-text-field
        id="prazo"
        name="prazo"
        label="Prazo"
        v-mask="['##/##/####']"
        v-model="projeto.prazo"
        required>
      </v-text-field>

        </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="menu = false">Cancel</v-btn>
        <v-btn color="primary" flat @click="cadastrarPrazoProjeto">Save</v-btn>
      </v-card-actions>
    </v-card>
   </v-menu>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  name: "ProjetoPrazo",
  directives: { mask },
  props: {
    projeto: {
      type: Object,
      required: true
    },
    formandos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    cadastrarPrazoProjeto() {
      let updates = {};
      updates[
        "/projetos/" + this.projeto[".key"] + "/prazo"
      ] = this.projeto.prazo;
      for (let formando of this.formandos) {
        let emailkey = formando[".key"];
        updates[
          "/users/" +
            emailkey +
            "/projeto/projetos/" +
            this.projeto[".key"] +
            "/prazo"
        ] = this.projeto.prazo;
        updates[
          "/projetos/" +
            this.projeto[".key"] +
            "/formandos/" +
            emailkey +
            "/prazo"
        ] = this.projeto.prazo;
      }
      this.$db.ref().update(updates);
      this.menu = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProjetoPrazo.vue